export const systemColors = {
  warningYellow: '#FFD95F',
  red: '#FF3E3E',
} as const;
